<script lang="ts">
  import { storyblokEditable } from '@storyblok/svelte';
  import { PageSection } from '@athena-lib/Page';
  import type { MediaPageSectionBlock } from '@storyblok-types';
  import clsx from 'clsx';
  import { Play } from '@athena-lib/Icons';
  import { Modal } from '@athena-lib/Modal';
  import ImageOrVideo from './ImageOrVideo.svelte';
  import { getFocalPointClasses } from './shared/image-utils';

  const { blok }: { blok: MediaPageSectionBlock } = $props();
  let showVideo = $state(false);

  const aspectRatios = {
    '1:1': 'aspect-square',
    '3:2': 'aspect-3/2',
    '16:9': 'aspect-video',
  };
</script>

{#if blok.media}
  <PageSection
    id={blok.elementId}
    action={storyblokEditable}
    actionArg={blok}
    ySpace={{ top: blok.topPadding ?? 'medium', bottom: blok.bottomPadding ?? 'medium' }}
    backgroundColor={blok.backgroundColor ?? 'light'}
  >
    <div class={clsx(aspectRatios[blok.aspectRatio || '3:2'], 'relative overflow-clip')}>
      <ImageOrVideo
        autoplay={blok.autoplayVideo}
        muted={blok.autoplayVideo}
        asset={blok.media}
        class="h-full w-full object-cover"
        innerImageClass={clsx('h-full w-full object-cover', getFocalPointClasses(blok.media))}
      />
      {#if blok.youtubeVideoId}
        <button
          type="button"
          onclick={() => (showVideo = true)}
          class="absolute left-0 top-0 flex h-full w-full items-center justify-center"
        >
          <Play sizeClass="h-24 text-st-white aspect-square drop-shadow-md" />
        </button>
      {/if}
    </div>
  </PageSection>
{/if}
<Modal
  showModal={showVideo}
  closable
  onClose={() => (showVideo = false)}
  size="lg"
  class="flex aspect-video flex-col"
  center
>
  {#if showVideo}
    <iframe
      title="YouTube video"
      class="w-full flex-grow"
      src={`https://www.youtube.com/embed/${blok.youtubeVideoId}?autoplay=1&mute=1&rel=0`}
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  {/if}
</Modal>
